var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCreateZendeskTicket = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#563BCE",
    d: "M21.75 12c0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25s9.75 4.365 9.75 9.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBFA",
    d: "M17.25 15.938a.263.263 0 0 0-.262-.263h-.6v-.6a.263.263 0 0 0-.526 0v.6h-.6a.26.26 0 0 0-.262.26v.002c0 .146.118.263.262.263h.6v.6c0 .144.117.261.26.262h.003a.263.263 0 0 0 .262-.262v-.6h.6a.263.263 0 0 0 .263-.262"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBFA",
    fillRule: "evenodd",
    d: "M18.375 15.938a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0m-2.25 1.687a1.687 1.687 0 1 0 0-3.375 1.687 1.687 0 0 0 0 3.375",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBFA",
    d: "M6 13.575q0-.03.004-.057L6 13.462c0-.227.189-.406.407-.47a1.426 1.426 0 0 0 0-2.733C6.189 10.194 6 10.015 6 9.788q0-.029.004-.055L6 9.675v-1.05a1.5 1.5 0 0 1 1.5-1.5h8.25a1.5 1.5 0 0 1 1.5 1.5v3.713a.45.45 0 1 1-.9 0V8.625a.6.6 0 0 0-.6-.6H7.5a.6.6 0 0 0-.6.6v.937a2.25 2.25 0 0 1 0 4.126v.937a.6.6 0 0 0 .6.6h4.875v.006a.45.45 0 0 1 0 .888v.006H7.5a1.5 1.5 0 0 1-1.5-1.5z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCreateZendeskTicket);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/create-zendesk-ticket.6e7829d4.svg";